import React from 'react';
import Select from "react-select"
import { BooleanOptions } from 'common/SelectOptions/BooleanOptions';
import { theme } from 'common/selectCustomStyles';

function AGRASupportedDropdown({selectedOption, setSelectedOption, width = "7rem"}) {

    return (
        <div className="flex items-center">
            <h6 className="text-nowrap font-normal">AGRA supported:</h6>
            <div className="ms-2" style={{ width: width }}>
                <Select
                    isClearable
                    options={BooleanOptions}
                    defaultValue={selectedOption}
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="Select"
                    theme={theme}
                    onChange={option => setSelectedOption(option)}
                />
            </div>
        </div>
    );
}

export default AGRASupportedDropdown;